import * as types from './types';

const CONSOLE_ZEN_REDIRECT_ROOT_PATH = '/console-zen';
const HELP_REDIRECT_ROOT_PATH = '/help';

const logPrefixes = {
  domain: '[Domain]',
  search: '[Search]',
};

const supportPathToConsoleUrlMap = {
  // Overview
  [types.LegacySupportPaths.overview]: '/us1/support/overview',
  // Create ticket
  [types.LegacySupportPaths.create]: '/us1/support/submit-ticket',
  // Ticket history
  [types.LegacySupportPaths.history]: '/us1/support/tickets',
  // Support plans
  [types.LegacySupportPaths.supportPlans]: '/us1/support/plans',
  /**
   * Fake path that allows useOscRedirect to open OSC in the same tab
   * when a user is logging in from OSC. Temporary workaround until
   * deeplinking functionality in Console Navigation Backend is updated
   * to support 'help' subdomain
   */
  [types.LegacySupportPaths.login]: '/us1/support/login',
  [types.LegacySupportPaths.loginToSubmit]: '/us1/support/login-submit',
};

export const knowledgeBaseUrlType = {
  [types.KnowledgeBaseUrlKey.article]: '/articles/',
  [types.KnowledgeBaseUrlKey.category]: '/categories/',
  [types.KnowledgeBaseUrlKey.section]: '/sections/',
  [types.KnowledgeBaseUrlKey.articleAttachments]: '/article_attachments/',
};

export const knowledgeBaseUrlRoot = {
  [types.KnowledgeBaseUrlKey.article]: '/articles/',
  [types.KnowledgeBaseUrlKey.category]: '/categories/',
  [types.KnowledgeBaseUrlKey.section]: '/sections/',
  [types.KnowledgeBaseUrlKey.articleAttachments]:
    'https://twilio.zendesk.com/hc/article_attachments/',
  default: '/',
};

export default {
  CONSOLE_ZEN_REDIRECT_ROOT_PATH,
  HELP_REDIRECT_ROOT_PATH,
  knowledgeBaseUrlType,
  knowledgeBaseUrlRoot,
  logPrefixes,
  supportPathToConsoleUrlMap,
};
